import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Plotly from 'plotly.js-dist';
import { Camera } from '@/models/camera';
import { format, differenceInDays } from 'date-fns';
import { State } from 'vuex-class';
import { BatteryLevel } from '@/models/batterylevel';

@Component
export default class BatterieLevelComponent extends Vue {
  @Prop({ type: Object, required: true }) public readonly camera!: Camera;
  @State('locale', { namespace: 'profile' }) public locale!: string;

  public get dateFormat(): string {
    return this.locale === 'en' ? 'MM/dd' : 'dd/MM';
  }

  public get plotlyData(): any[] {
    if (this.camera?.batteryLevels && this.camera.batteryLevels.length > 0) {
      return [
        {
          x: this.camera.batteryLevels.map((level) => format(new Date(level.date), 'yyyy-MM-dd HH:mm:ss')),
          y: this.camera.batteryLevels.map((level) => level.level),
          type: 'scatter',
          mode: 'lines+markers',
          fill: 'tozeroy',
          marker: { color: '#4dffcd' },
          hovertemplate: 'Date: %{x|%d/%m/%y}<br>Heure: %{x|%H:%M:%S}<br>Batterie: %{y}%<extra></extra>',
          hoverlabel: {
            font: {
              color: '#ffffff', // Couleur du texte en blanc
            },
          },
        },
      ];
    }
    return [];
  }

  public resizeBatteryGraph(): void {
    const chartDiv = this.$refs.chart as HTMLDivElement;
    if (chartDiv && this.plotlyData.length > 0) {
      Plotly.Plots.resize(chartDiv);
    }
  }

  public mounted(): void {
    this.updatePlotlyGraph();
  }

  private updatePlotlyGraph(): void {
    const chartDiv = this.$refs.chart as HTMLDivElement;
    if (!chartDiv) return;

    if (this.plotlyData.length === 0) {
      // Optionnel : Effacer le graphique existant si aucune donnée
      Plotly.purge(chartDiv);
      return;
    }
    if (chartDiv && this.plotlyData.length > 0) {
      const layout = {
        title: {
          text: 'Niveau de Batterie',
          font: { color: '#5fc9e4' },
        },
        xaxis: {
          title: { text: 'Date', font: { color: '#5fc9e4' } },
          tickfont: { color: '#5fc9e4' },
          tickformat: '%d/%m/%y',
          showgrid: true,
          gridcolor: '#44475a',
          gridwidth: 1,
          tickangle: 70,
        },
        yaxis: {
          title: { text: 'Niveau de Batterie (%)', font: { color: '#5fc9e4' } },
          tickfont: { color: '#5fc9e4' },
          range: [0, 100],
          showgrid: true,
          gridcolor: '#44475a',
          gridwidth: 1,
        },
        autosize: true,
        margin: {
          l: 50,
          r: 0,
          b: 90,
          t: 30,
          pad: 0,
        },
        paper_bgcolor: 'rgba(0,0,0,0)',
        plot_bgcolor: 'rgba(0,0,0,0)',
      };

      const config = {
        responsive: true,
        scrollZoom: true,
      };

      Plotly.react(chartDiv, this.plotlyData, layout, config);
    }
  }

  @Watch('camera.batteryLevels', { immediate: true, deep: true })
  public onBatteryLevelsChange(): void {
    this.updatePlotlyGraph();
  }
}
